import { t } from '../../i18n.es.js';
import React from 'react';
import { LazyImage } from '@teko/ui';
import emptyImage from './search-no-result.es.js';
import { Flex } from '../Flex/Flex.es.js';
import { Text } from '../Text/Text.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EmptyState = (_a) => {
  var _b = _a, {
    text
  } = _b, props = __objRest(_b, [
    "text"
  ]);
  return /* @__PURE__ */ React.createElement(Flex, __spreadProps(__spreadValues({}, props), {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }), /* @__PURE__ */ React.createElement(LazyImage, {
    height: 128,
    width: 128,
    src: emptyImage
  }), /* @__PURE__ */ React.createElement(Text, {
    fontSize: 12,
    color: "#848788",
    marginTop: "24px",
    paddingX: "2rem"
  }, text || t("Kh\xF4ng t\xECm th\u1EA5y d\u1EEF li\u1EC7u")));
};

export { EmptyState };
